export const PasswordRegExp = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=.*[#!@$%^&*]).{8,}$/;
export const PhoneNumberRegExp = /^[ +()/0-9-]{6,20}$/;

export const resizeImage = (base64string: string, maxWidth = 1024, maxHeight = 1024) =>
  new Promise<string>((resolve) => {
    const img = new Image();
    img.src = base64string;

    img.onload = () => {
      const MAX_WIDTH = maxWidth;
      const MAX_HEIGHT = maxHeight;
      const width = img.width;
      const height = img.height;
      let toResize = false;

      if (width <= maxWidth || height <= maxHeight) {
        return resolve(base64string);
      }

      toResize = true;

      /* if (width > height) {
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;
        toResize = true;
      }
    } else {
      if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
        toResize = true;
      }
    } */

      const min = Math.min(MAX_WIDTH, MAX_HEIGHT);

      if (toResize) {
        const canvas = document.createElement('canvas');
        canvas.width = min;
        canvas.height = min;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0, min, min);
          resolve(canvas.toDataURL());
        }
      } else {
        resolve(base64string);
      }
    };
  });
